var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatusError = function SvgStatusError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5C00",
    d: "m2.534 19.074 7.695-14.69c.748-1.429 2.794-1.429 3.543 0l7.695 14.69c.697 1.332-.269 2.928-1.772 2.928H4.305c-1.503 0-2.468-1.596-1.77-2.928"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5C00",
    fillRule: "evenodd",
    d: "m.762 18.146 7.695-14.69c1.497-2.858 5.59-2.858 7.087 0l7.694 14.69c1.395 2.663-.537 5.856-3.543 5.856H4.305c-3.006 0-4.938-3.192-3.543-5.856M10.23 4.384l-7.695 14.69c-.697 1.332.268 2.928 1.772 2.928h15.389c1.503 0 2.47-1.596 1.772-2.928l-7.695-14.69c-.749-1.429-2.795-1.429-3.543 0",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.519 7.64-.278 8.58H10.76l-.278-8.58zm-1.522 12.54q-.645 0-1.11-.46a1.51 1.51 0 0 1-.46-1.11q0-.64.46-1.093.465-.459 1.11-.459.623 0 1.093.459.477.453.477 1.093 0 .435-.223.79a1.65 1.65 0 0 1-.574.568q-.349.21-.773.211"
  })));
};
export default SvgStatusError;